import { InjectionToken } from "@angular/core";
import { LogLevel } from "@azure/msal-common";

export interface AuthConfig {
  /** If not provided defaults to 'https://login.microsoftonline.com/f5c71729-7816-4984-867a-0b3a69f99ff8/' */
  authority?: string;
  clientId: string;
  /** If set enables logging. */
  logLevel?: LogLevel;
  /**
   * This is no a redirect url but the reply url configured in azure ad.  Since we're using popup, the user isn't redirected.
   * Defaults to the just the domain portion of the url.
   */
  replyUrl?: string;
  /** if not provided defaults to /. */
  postLoginRedirectUri?: string;
  /** if not provided defaults to unauhtorized page. */
  postLogoutRedirectUri?: string;
  /** a map of resourceBaseUrls and array of scopes required for that resource.  If no scope is provided a default is passed. */
  protectedResourceMap: Map<string, string[] | undefined | null>;
  /** if not provided will use auth/unauthorized. */
  unauthorizedRoute?: string;
}

/** Key for session storage where post login redirect urls from the auth guard are stored. */
export const SESSION_POST_LOGIN_REDIRECT_URL = 'SessionPostLoginRedirectUrl';
export const AUTH_CONFIG = new InjectionToken<AuthConfig>('configuration required by auth module');

export function normalizeScopesArray(scopesOrEmpty: string[] | undefined | null): string[] {
  return (scopesOrEmpty == null) ? [] : scopesOrEmpty;
}
